import type { InferResponseType } from 'hono/client';
import { type ApiClient, useFetch } from '../api';

type GetDeviceFiles =
  ApiClient['v2']['workspaces'][':workspaceId']['devices'][':deviceId']['files']['$get'];
export type DeviceFileListResponse = InferResponseType<GetDeviceFiles, 200>;
export type DeviceFile = DeviceFileListResponse['deviceFiles'][number];

export function useDeviceFiles(deviceId: number, workspaceId: number) {
  return useFetch<DeviceFileListResponse>(
    `workspaces/${workspaceId}/devices/${deviceId}/files`,
    (client) =>
      client.v2.workspaces[':workspaceId'].devices[':deviceId'].files.$get({
        param: { workspaceId: workspaceId.toString(), deviceId: deviceId.toString() },
        query: { limit: 1000, sort: ['-id'] },
      })
  );
}
